type Props = {
  values: number[];
};

const formatPlaybackTime = (seconds: number): string => {
  if (seconds < 60) return `${seconds}s`;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

export default ({ values }: Props) => {
  const maxValue = Math.max(...values, 1);

  return (
    <svg width="56" height="22" viewBox="0 0 56 22" className="overflow-visible">
      {values.map((value, index) => {
        const barHeight = Math.max(2, Math.round((value / maxValue) * 18));
        const x = index * 8 + 1;
        const y = 20 - barHeight;

        return (
          <g key={`${index}-${value}`}>
            <rect x={x} y={y} width={6} height={barHeight} rx={2} className="fill-blue-400/70" />
            <title>{`Day ${index + 1}: ${formatPlaybackTime(value)}`}</title>
          </g>
        );
      })}
    </svg>
  );
};
